module.exports = __webpack_public_path__ + "static/img/materialsInfo14.2f6e60f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/materialsInfo14.png
// module id = H8j+
// module chunks = 2